import viewMode from "./components/viewMode";
import tabsJs from "./components/tabs";

export default function tabPanel() {
  jQuery(function () {
    viewMode();
    tabsJs();
  })
}